export default "__VITE_ASSET__CmIrIDP___"